import { render, staticRenderFns } from "./SSOPartnerSynchronizeDialog.vue?vue&type=template&id=5adbba8a&scoped=true"
import script from "./SSOPartnerSynchronizeDialog.vue?vue&type=script&lang=ts"
export * from "./SSOPartnerSynchronizeDialog.vue?vue&type=script&lang=ts"
import style0 from "./SSOPartnerSynchronizeDialog.vue?vue&type=style&index=0&id=5adbba8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbba8a",
  null
  
)

export default component.exports